import { Component, Input, OnInit } from '@angular/core';
import { FindPageDetails } from '@freelancer/datastore/collections';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { BackgroundColor, LogoSize } from '@freelancer/ui/logo';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-seo-sem-hero',
  template: `
    <fl-bit class="SeoSemHero">
      <fl-bit class="SeoSemHero-backgroundContainer"></fl-bit>
      <fl-container [mobilePadding]="true">
        <fl-link [link]="'/'" [flTrackingLabel]="'flLogo'">
          <fl-logo
            class="SeoSemHero-logo"
            [backgroundColor]="BackgroundColor.DARK"
            [size]="LogoSize.SMALL"
          ></fl-logo>
        </fl-link>
        <fl-grid class="SeoSemHero-grid">
          <fl-col class="SeoSemHero-text" [col]="12" [colDesktopSmall]="5">
            <ng-container *ngIf="isReady">
              <fl-heading
                [color]="HeadingColor.LIGHT"
                [size]="TextSize.XXLARGE"
                [headingType]="HeadingType.H1"
                [flMarginBottom]="Margin.XLARGE"
              >
                <ng-container *ngIf="skill; else default">
                  <ng-container *ngIf="skillDetails; else custom">
                    <ng-container *ngIf="skillDetails.header; else default">
                      <ng-container
                        *ngIf="skill === skillDetails.seoUrl; else plainHeader"
                        i18n="
                          Find page header, prompting users to find a certain
                          type of worker
                        "
                      >
                        Find {{ skillDetails.header }}
                      </ng-container>
                      <ng-template #plainHeader>
                        {{ skillDetails.header }}
                      </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-template #custom>
                    {{ skillAsHeader | titlecase }}
                  </ng-template>
                </ng-container>
                <ng-template #default>
                  <ng-container i18n="Find page default header">
                    Find Freelancers
                  </ng-container>
                </ng-template>
              </fl-heading>
              <fl-text
                i18n="Find Page description"
                [color]="FontColor.LIGHT"
                [size]="TextSize.LARGE"
                [flMarginBottom]="Margin.XXLARGE"
              >
                It's quick, easy, and we only need a few details to get started.
              </fl-text>
              <fl-bit
                *ngIf="
                  skillDetails?.subheader && skillDetails?.subheaderDescription
                "
                class="SeoSemHero-subheader"
                [flShowDesktop]="true"
              >
                <fl-heading
                  i18n="
                    Find page subheader, prompting users to hire a certain type
                    of worker
                  "
                  [color]="HeadingColor.LIGHT"
                  [headingType]="HeadingType.H2"
                  [size]="TextSize.XLARGE"
                  [flMarginBottom]="Margin.MID"
                >
                  Hire {{ skillDetails.subheader }}
                </fl-heading>
                <fl-text
                  class="SeoSemHero-subheader-description"
                  [innerHTML]="skillDetails.subheaderDescription"
                  [color]="FontColor.INHERIT"
                  [size]="TextSize.SMALL"
                >
                </fl-text>
              </fl-bit>
            </ng-container>
          </fl-col>
          <fl-col
            class="SeoSemHero-form-container"
            [col]="12"
            [colDesktopSmall]="7"
          >
            <fl-bit *ngIf="isReady" class="SeoSemHero-form">
              <fl-heading
                class="SeoSemHero-form-header"
                i18n="Find Page Post Job Header"
                [size]="TextSize.LARGE"
                [color]="HeadingColor.INHERIT"
                [headingType]="HeadingType.H2"
                [flMarginBottom]="Margin.MID"
              >
                Get Free Quotes
              </fl-heading>

              <app-form
                *ngIf="skillDetails?.subheader; else defaultForm"
                titlePlaceholder="eg. I need {{ skillDetails.subheader }}"
                i18n-titlePlaceholder="
                  Post Project title placeholder, stating that user needs a
                  certain type of worker
                "
              ></app-form>
              <ng-template #defaultForm>
                <app-form></app-form>
              </ng-template>
            </fl-bit>
          </fl-col>
        </fl-grid>
      </fl-container>
    </fl-bit>
  `,
  styleUrls: ['./seo-sem-hero.component.scss'],
})
export class SeoSemHeroComponent implements OnInit {
  BackgroundColor = BackgroundColor;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  LogoSize = LogoSize;
  Margin = Margin;
  TextSize = TextSize;

  @Input() isReady: boolean;
  @Input() skill: string;
  @Input() skillDetails: FindPageDetails;

  skillAsHeader: string;

  ngOnInit() {
    if (this.skill) {
      this.skillAsHeader = this.skill.replace(/-/g, ' ');
    }
  }
}
